import { createFileRoute } from '@tanstack/react-router'

import { AssetsPage } from '@/pages/assets/assets-page'

export const Route = createFileRoute('/_private/assets')({
  component: AssetsPage,
})
